import algoliaSearchInsights from 'search-insights';

class AlgoliaEvent {
  algoliaEvent;

  customEventName;

  constructor(hashIds) {
    this.initAlgolia();
    this.findKeyAndPriceFromSession(hashIds);
  }

  findKeyAndPriceFromSession(searchValues) {
    const storedData = sessionStorage.getItem('hashObjectIdMap');
    if (!storedData) {
      return;
    }

    const data = JSON.parse(storedData);

    Object.entries(data).forEach(([ key, value ]) => {
      let { hashIds } = value;
      const { price } = value;
      if (!Array.isArray(hashIds)) {
        hashIds = [ hashIds ];
      }
      if (searchValues.every((val) => hashIds.includes(val)) && hashIds.length === searchValues.length) {
        this.key = key;
        this.price = price;
      }
    });
  }

  initAlgolia() { // eslint-disable-line class-methods-use-this
    algoliaSearchInsights('init', {
      appId: window.algolia_app_id,
      apiKey: window.algolia_api_key,
    });
  }

  async send() {
    await algoliaSearchInsights(this.algoliaEvent, {
      eventName: this.customEventName,
      index: `${window.algolia_index_prefix}_office-offer`,
      objectIDs: [ this.key ],
      objectData: [
        {
          queryID: sessionStorage.getItem('queryID'),
          price: this.price,
        },
      ],
      currency: 'EUR',
    });
  }
}

export default AlgoliaEvent;
